// Delegation also covers sections replaced by the theme editor. A module runs once
// per page, so multiple collection sections do not create duplicate listeners.
document.addEventListener('focusin', (event) => {
  const tile = event.target.closest?.('.tcv-collections .tcv-collection-card');
  if (!tile?.matches(':focus-visible')) return;

  const grid = tile.parentElement;
  if (!grid?.matches('.tcv-collections__grid') || grid.scrollWidth <= grid.clientWidth) return;

  // Native keyboard focus can leave a partially visible card clipped in a snap
  // scroller. Reveal it without animation, including for reduced-motion users.
  tile.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
});
